module.exports = "<form class=\"spaceTop\">\n    <textarea\n        placeholder=\"Dodaj komentarz\"\n        ng-model=\"IssueViewJournalCtrl.notesToBackend\"\n    >\n    </textarea>\n    <select\n        ng-model=\"IssueViewJournalCtrl.commentVisibility\"\n        ng-options=\"item.value as item.key for item in IssueViewJournalCtrl.commentVisibilityOptions\"\n    ></select>\n    <button\n        class=\"btn-standard\"\n        ng-click=\"IssueViewJournalCtrl.sendDataToBackend()\"\n    >\n        Dodaj\n    </button>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_view/journal/journal.html
// module id = 680
// module chunks = 0